// localStorage cache of events created on this device, so the creating browser
// can show a "Your events" list and recover manage links. This is a convenience
// only; true ownership is the capability token in the manage URL.

const KEY = 'irl.myEvents.v1';

export interface OwnedEvent {
  id: string;
  name: string;
  manageUrl: string;
  publicUrl: string;
  savedAt: string; // ISO
}

export function listOwned(): OwnedEvent[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as OwnedEvent[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function rememberOwned(e: OwnedEvent): void {
  const list = listOwned().filter((x) => x.id !== e.id);
  list.unshift(e);
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100)));
  } catch {
    // storage full or disabled; ignore
  }
}

export function forgetOwned(id: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(listOwned().filter((x) => x.id !== id)));
  } catch {
    // ignore
  }
}

// Extract the edit token from a manage URL path: /e/:id/manage/:token
export function tokenFromManageUrl(url: string): string | null {
  const m = /\/manage\/([^/?#]+)/.exec(url);
  return m ? decodeURIComponent(m[1]) : null;
}
